export const bookingSystem = {
  seo: {
    title: "Foglalás — Bespire AI asszisztens",
    description:
      "Online foglalás, naptár, emlékeztetők, csoportos órák — a Bespire AI asszisztens egyik képessége, nem külön termék.",
  },
  hero: {
    badge: "Foglalás",
    title: "Foglalás, ami magától vezeti a naptáradat",
    subtitle:
      "Az ügyfél foglal, a Bespire AI megerősít, emlékeztet, újraütemez, no-show után újrahív. Te csak megjelensz az időpontokon.",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaPricing: "Nézd meg az árakat →",
    bookingCard: {
      label: "Foglalási felület · illusztráció",
      businessName: "Bella Studio · Kismama jóga",
      day: "Csütörtök · Szeptember 12",
      slots: [
        { time: "16:00", state: "free" as const, label: "Szabad" },
        { time: "17:00", state: "selected" as const, label: "Kiválasztva" },
        { time: "18:00", state: "booked" as const, label: "Foglalt" },
        { time: "19:00", state: "free" as const, label: "Szabad" },
      ],
      confirmLabel: "Megerősítve",
      confirmMessage: "17:00-ra vártunk. Emlékeztetőt küldünk 2 órával előtte.",
      cta: "Foglalás megerősítése",
    },
  },
  process: {
    title: "Három lépés, hogy a foglalás magától menjen",
    subtitle:
      "Ugyanaz a rendszer, ami a weboldalad, a marketinged és az ügyféllevélezésed — most a naptáradat is vezeti.",
    steps: [
      {
        step: "01",
        icon: "Calendar",
        title: "Egyszer beállítod",
        description:
          "Szolgáltatások, időtartamok, árak, szünetek, munkarend. A Bespire AI végigkérdez chatben — 10 perc alatt kész.",
        bullets: [
          "Egyéni és csoportos órák",
          "Buffer időzítés a foglalások között",
          "Több helyszín, több szolgáltató kezelése",
        ],
      },
      {
        step: "02",
        icon: "Bot",
        title: "Az asszisztens vezet",
        description:
          "Az ügyfél foglal, fizet, megerősítést kap. Ütközést nem enged, várólistát tart, csoportos órák telítettségét mutatja.",
        bullets: [
          "Online fizetés vagy helyszínen",
          "Automatikus e-mail és SMS/WhatsApp",
          "Naptár-szinkron Google/Apple/Outlook felé",
        ],
      },
      {
        step: "03",
        icon: "Bell",
        title: "Utána is figyel",
        description:
          "Emlékeztet, újraütemez, no-show után újrahív, visszajelzést kér. A no-show arányod észrevehetően csökken.",
        bullets: [
          "24 órás és 2 órás emlékeztetők",
          "Egy kattintásos átütemezés",
          "Automatikus visszajelzés-kérés a látogatás után",
        ],
      },
    ],
  },
  beforeAfter: {
    title: "Előtte–utána: ugyanaz a hét",
    subtitle:
      "Nem több óra a napban — kevesebb üresjárat és kevesebb elmaradás.",
    before: {
      label: "Előtte",
      businessName: "Kézi naptár + üzenetek",
      tagline: "Foglalás Messengeren, egyeztetés e-mailben, papír naptár.",
      bio: "Napi 30–40 perc egyeztetés. Néha kimarad egy időpont, néha kétszer foglalsz be. Emlékeztetőt magad küldesz, ha van rá időd.",
      problems: [
        "Egyeztetés Messengerben, e-mailben, telefonon",
        "Ütközések, kétszeres foglalás",
        "Emlékeztetőt kézzel kell küldeni",
        "No-show-t senki nem követi",
      ],
    },
    after: {
      label: "Utána",
      businessName: "Foglalás a Bespire-ből",
      tagline: "Egy naptár, minden csatornán ugyanaz.",
      bio: "Az ügyfél a weboldalon foglal, a rendszer megerősít, emlékeztet, újraütemez. Te csak megjelensz — vagy szólsz a Bespire-nek, hogy mit írjon át.",
      wins: [
        "Egy naptár, minden csatornán élő",
        "Automatikus megerősítés + emlékeztető",
        "No-show automatikus követés",
        "Napi 30+ perc szabadul fel",
      ],
    },
  },
  showcase: {
    title: "Egy nap a naptáradban",
    subtitle:
      "Valós példa. Az asszisztens minden szürke feladatot elintéz körülötted.",
    day: [
      { time: "07:30", icon: "Sunrise", title: "Napi felkészítés", note: "8 megerősített foglalás, 1 várólistás. A 10:00-s ügyfél új — arckezelést kér.", tag: "brief" },
      { time: "09:00", icon: "Users", title: "Csoportos jóga (7/8)", note: "Utolsó helyre a Bespire automatikusan mozgatja Anna várólistás foglalását.", tag: "csoport" },
      { time: "10:00", icon: "Calendar", title: "Új ügyfél — Klasszikus arckezelés", note: "Előre fizetve. Előzményt és allergiakérdőívet ellenőriztük.", tag: "1:1" },
      { time: "12:30", icon: "AlertTriangle", title: "Lemondás Tímeától", note: "A Bespire kiajánlotta a slotot a várólistának. 3 percen belül elkelt.", tag: "váró" },
      { time: "14:00", icon: "Bell", title: "Emlékeztetők a 16:00-s órára", note: "6 vendégnek WhatsApp + e-mail. 1 fő kért újraütemezést — kész.", tag: "emlékeztető" },
      { time: "18:30", icon: "Star", title: "Nap zárása", note: "5 új foglalás, 0 ütközés, 0 no-show. Holnap 9 időpont vár.", tag: "összegzés" },
    ],
    kpis: [
      { label: "Napi egyeztetés-idő", value: "0 perc", note: "kb. 30–40 percről" },
      { label: "No-show arány", value: "−58%", note: "3 hónap átlagában" },
      { label: "Kihasználtság", value: "+22%", note: "várólista + emlékeztetők miatt" },
    ],
  },
  chat: {
    title: "Szólj a naptárad felé, mint egy asszisztensnek",
    subtitle:
      "Csak nem valaki más naptárával piszkál, hanem az asszisztensed a tiéddel.",
    chat: {
      title: "Foglalási asszisztens",
      online: "Online",
      messages: [
        { role: "user" as const, content: "Holnap 10-től 14-ig nem tudok jönni, orvoshoz kell mennem." },
        { role: "assistant" as const, content: "Rendben, blokkolom az idősávot. Van 4 foglalásod ebben az időben:", list: [
          "10:00 · Anna — Klasszikus arckezelés",
          "11:30 · Béla — Konzultáció",
          "12:30 · Klára — Mélytisztító",
          "13:30 · Réka — Első alkalom",
        ] },
        { role: "user" as const, content: "Írj nekik, ajánlj új időpontot ugyanarra a hétre." },
        { role: "assistant" as const, content: "Elment mind a 4-nek WhatsApp + e-mail üzenet, mindegyiknek 2 alternatíva. Frissítek, amint válaszolnak. 💜" },
        { role: "user" as const, content: "Kösz. Hétvégén szeretnék egy extra csoportos órát nyitni." },
        { role: "assistant" as const, content: "Kész: szombat 10:00, 8 fős kismama jóga, feltéve az oldalra, kimenő poszt Instára. Előnézet?" },
      ],
    },
  },
  crossLinks: {
    title: "A foglalás nem áll meg itt",
    subtitle: "A Bespire ugyanezt az ügyfelet viszi tovább az emlékeztetőn, a marketingen, a vélemény-kérésen és a napi ritmusodon át.",
  },
  cta: {
    title: "Automatizáld a foglalást ma",
    subtitle: "3 nap ingyenes próba, kártya nélkül.",
    primary: "Próbáld ki 3 napig ingyen",
    secondary: "Árak megnézése",
  },
};
